import React from "react";
import { Api_EndPoints } from "../../utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";

const addDepartment = async (input) => {
  const data = await http_payroll.post(
    Api_EndPoints.AddDepartment,
    input
  );
  return data;
};

export const useAddDepartmentMutation = () => {
  return useMutation({
    mutationFn: addDepartment,
  });
};
